import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from './firebase';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import ProfilePage from './pages/ProfilePage';
import BaristaPanel from './pages/BaristaPanel';
import { getUserRole } from './utils/getUserRole';
import BookPage from './pages/BookPage';
import PopularPage from './pages/PopularPage';
import NearbyPage from './pages/NearbyPage';
import CategoryPage from './pages/CategoryPage.js';
import SearchPage from './pages/SearchPage';
import FiltersPage from './pages/FiltersPage';
import { onAuthStateChanged } from 'firebase/auth';
import ensureUserDoc from './utils/ensureUserDoc';
import CafePage from "./pages/CafePage";
import PriceCalculator from "./pages/PriceCalculator";
import HowItWorks from "./pages/HowItWorks";
import CafesList from "./pages/CafesList";
import Rules from "./pages/Rules";
import Partners from "./pages/Partners";
import RefundPolicyPage from "./pages/RefundPolicyPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsAndConditionsPage from "./pages/TermsAndConditionsPage";
import FavoriteCafesBooksPage from "./pages/FavoriteCafesBooksPage";


const AppContent = () => {
  const location = useLocation();
  const [user] = useAuthState(auth);
  const navigate = useNavigate();


  
  useEffect(() => {
    const checkUserRole = async () => {
    console.log('🔍 PATH:', location.pathname);
    console.log('🔍 USER:', user);
    console.log('🔍 localStorage role:', localStorage.getItem('userRole'));

      if (user && location.pathname === '/' && !localStorage.getItem('userRole')) {
        const role = await getUserRole(user.uid);
        if (role === 'barista') {
          navigate('/barista/panel');
        }
      }
    };
    checkUserRole();
  }, [user, location]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname, location.search]);

  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/barista/panel" element={<BaristaPanel />} />
        <Route path="/book/:isbn" element={<BookPage />} />
        <Route path="/popular" element={<PopularPage />} />
        <Route path="/near" element={<NearbyPage />} />
        <Route path="/category" element={<CategoryPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/filters" element={<FiltersPage />} />
        <Route path="/cafe/:name" element={<CafePage />} />
        <Route path="/calc" element={<PriceCalculator />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/cafes" element={<CafesList />} />
        <Route path="/rules" element={<Rules />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/top-up" element={<Navigate to="/" replace />} />
        <Route path="/refund-policy" element={<RefundPolicyPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
        <Route path="/favorite-cafes-books" element={<FavoriteCafesBooksPage />} />

      </Routes>
    </>
  );
};

const App = () => (
  <Router>
    <AppContent />
  </Router>
);

export default App;
